<template>
  <div class="definition-list__divider" data-test-definition-list-divider>
  </div>
</template>
